import React from 'react';
interface TrustLineProps {
  items: string[];
}
export function TrustLine({
  items
}: TrustLineProps) {
  return <p className="mt-2 text-center font-display text-xs font-semibold uppercase tracking-wide text-graphite sm:text-sm" data-id="element-194" data-mp="3oxdpw95eg11l">
      {items.map((item, i) => <React.Fragment key={item} data-id="element-195" data-mp="3fxqovogl0x92" data-mpi={i}>
          {i > 0 && <span className="mx-1.5 text-gold-dark" data-id="element-196" data-mp="3fz23ykfh9rfh">|</span>}
          {item}
        </React.Fragment>)}
    </p>;
}